/**
 * Which materials the pricing engine still treats specially.
 *
 * The engine and the UI both read this module, so the notice shown while a
 * material is being picked cannot drift from the formula that bills it.
 *
 * Only one rule is left, and it is a property of the MATERIAL rather than of
 * the thing it is used in, so it applies wherever the board goes — carcass,
 * front, back, cut-list piece, countertop, backsplash, drawer or panel alike:
 *
 *   GLASS_SANDING — `Material.glassSanding`. Multiplies that material's own
 *     cost by `glassSandingMarkup` (1.30 by default, a system setting). Edge
 *     banding is a different material and is not marked up.
 *
 * There used to be a second rule, FIXED_PRICE_NAME: a board whose name contained
 * "vopsit" or "furniruit" had the item's coefficient skip its cost. It was a
 * substring match standing in for a number nobody could edit — it exempted a
 * "Blat vopsit termorezistent" that did carry a markup, and missed a fixed-price
 * board that happened not to say so in its name. `Material.coefficient` replaced
 * it: those boards now simply carry 1, set by migration and correctable in the
 * catalog like any other.
 */

export type SpecialMaterialRule = 'GLASS_SANDING';

/** The subset of a material the rules look at. */
export interface SpecialMaterialInput {
  name?: string | null;
  glassSanding?: boolean | null;
}

/**
 * Every special-pricing rule this material triggers. Empty for an ordinary
 * board.
 */
export function specialMaterialRules(material: SpecialMaterialInput): SpecialMaterialRule[] {
  return material.glassSanding ? ['GLASS_SANDING'] : [];
}
